<template>
  <div v-html="processedContent" class="ai-assistant-text" />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import useMarkdown from '@/common/markdown/useMarkdown'

export default defineComponent({
  name: 'AIAssistantText',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const textRef = computed(() => props.text)
    const { processedContent } = useMarkdown(textRef)

    return {
      processedContent,
    }
  },
})
</script>
